import { fetchFinanceV2, getFinanceV2, putFinanceV2 } from "utils/api";

export const querySubmissionList = async () => {
  return await getFinanceV2("/submission_bank/configuration", {});
};

export const createSubmissionConfiguration = async (params) => {
  return await fetchFinanceV2("/submission_bank/configuration", { ...params });
};

export const updateSubmissionConfiguration = async (id, params) => {
  return await putFinanceV2(`/submission_bank/configuration/${id}`, {
    ...params,
  });
};
